//import ContactForm from "../../contact_form/contact_form";
import TarotCards from "../../tarot/presentation/tarot-cards";
import HomeHeader from "./header";
import HomeAbout from "./home-about";
import HomeFooter from "./home-footer";
import HomeSlider from "./home-slider";

export default function HomeBody() {
  
  return (
    <>
      <HomeHeader/>
			<HomeSlider/>
			<HomeAbout/>
			<TarotCards/>

			{/* <ContactForm/> */}
			<HomeFooter/>
			{/* <HomeDowload/> */}
    </>
  )
}